import React from 'react';
import GlobalBanner from './GlobalBanner';

export default function MaintenanceModeBanner(props: { shouldShow: boolean }) {
  return props.shouldShow && <GlobalBanner message={<p>Attention: GoFormz is performing routine maintenance. Some actions may be unavailable.</p>} />;
}
